import { render, staticRenderFns } from "./JDrawerLabel.vue?vue&type=template&id=1f068aea&scoped=true"
import script from "./JDrawerLabel.vue?vue&type=script&lang=js"
export * from "./JDrawerLabel.vue?vue&type=script&lang=js"
import style0 from "./JDrawerLabel.vue?vue&type=style&index=0&id=1f068aea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f068aea",
  null
  
)

export default component.exports